import script from "./Splitters.vue?vue&type=script&lang=js"
export * from "./Splitters.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__